import React from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

export default function ClubbedOtpAccordion({ data, handleSelect, handleAccordionExpansion, isImpactedPolicyScreen = false }) {
    const { insurerName, planName, premiumPayTerm, policyNumber, premiumAmount, policyTerm, isExpanded, checked, id } = data;
    return (
        <Accordion className="accordianWrap" expanded={isExpanded === true}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon onClick={() => handleAccordionExpansion(id)} />}
                aria-controls="panel1-content"
                id="panel1-header"
            >
                <div className="tableWrapper">
                    <div className="row">
                        {!isImpactedPolicyScreen && <div className="col-check">
                            <input
                                type="checkbox"
                                id={`lifeInsured${id}`}
                                checked={checked}
                                onChange={(e) => handleSelect(e, id)}
                            />
                            <label htmlFor={`lifeInsured${id}`} id="labelCheckbox"></label>
                        </div>}
                        <div className="col-1">
                            <div className="row">
                                <div className="col-2">
                                    <div className="pol-name">Life to be insured</div>
                                    <div className="bl-text">{insurerName}</div>
                                </div>
                                <div className="col-3">
                                    <div className="pol-name">Policy Number</div>
                                    <div className="bl-text">{policyNumber}</div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-2">
                                    <div className="term-text">Premium Payment Term</div>
                                    <div className="year">{premiumPayTerm} yrs</div>
                                </div>
                                <div className="col-3">
                                    <div className="term-Amount">Premium Amount</div>
                                    <div className="year">₹ {premiumAmount}</div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </AccordionSummary>
            <AccordionDetails className="accordionDetails">
                <div className="row">
                    <div className="col-1">
                        <div className="row">
                            <div className="col-2">
                                <div className="pol-name">Policy Term</div>
                                <div className="bl-text">{policyTerm} yrs</div>
                            </div>
                            <div className="col-3">
                                <div className="pol-name">Plan Name</div>
                                <div className="bl-text">{planName}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </AccordionDetails>
        </Accordion>
    )
}
